import React from 'react';
import { useNavigate } from 'react-router';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { Divider } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import eytanimage from "src/Assets/Images/eytan.png"
import useTailwindBrand from 'src/Theme/useTailwindBrand';
import { useProcurationContext } from 'src/Contexts/ProcurationContext';
import ButtonField from 'src/Components/Ui/ButtonField';
import { getActiveBrandConfig } from 'src/config/environment.config';

const FirstProcuration = (props: any) => {
    const navigate = useNavigate()
    const { classes, common } = useTailwindBrand()
    const context = useProcurationContext()
    const { typeOfProcuration } = context

    return (
        <div className="w-full">
            <div className="text-center mb-8">
                <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-blue-50 mb-6">
                    <AssignmentIcon className={`w-10 h-10 ${classes.primaryText}`} />
                </div>
                <h1 className={`${classes.primaryText} ${classes.fontFamily} text-2xl lg:text-3xl font-bold mb-4`}>
                    Bienvenue dans l'espace Procuration
                </h1>
                <p className={`${common.body} text-gray-600 text-lg w-full mx-auto`}>
                    {typeOfProcuration === 30 ?
                        `Créez votre procuration pour devenir auto-entrepreneur en quelques étapes simples` :
                        `Créez votre procuration pour obtenir votre déclaration SAP`}
                    <br /> En nous délivrant celle - ci, vous nous permettez de faire toutes les démarches administratives à votre place.
                </p>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-md p-6 lg:p-8 mb-8 border border-blue-100">
                <div className="flex items-start gap-4 mb-6">
                    <img src={eytanimage} alt="Eytan" className="w-16 h-16 rounded-full object-cover flex-shrink-0" />
                    <div className="flex-1">
                        <div className="flex items-center gap-2 mb-2">
                            <p className={`font-bold text-lg ${classes.primaryText} ${classes.fontFamily}`}>Eytan</p>
                            <CheckCircleIcon className="w-5 h-5 text-green-500" />
                        </div>
                        <p className={`${common.body} text-gray-700 leading-relaxed`}>
                            Bienvenue dans l'espace de création de votre procuration pour devenir auto-entrepreneur.
                            <br />
                            En nous délivrant celle-ci, vous nous permettez de faire toutes les démarches administratives à votre place.
                        </p>
                    </div>
                </div>
            </div>
            <Divider />
            <div className="flex justify-end pt-6">
                <div className="flex flex-col lg:flex-row w-full justify-between">
                    <ButtonField
                        label={"Précédent"}
                        variant="outlined"
                        className={`w-full font-bold lg:w-auto `}
                        onClick={() => navigate(`/${getActiveBrandConfig()}/tableau-de-bord/complete`)}
                    />
                    <ButtonField
                        label={"C'est parti !"}
                        variant="contained"
                        className={`w-full font-bold lg:w-auto `}
                        onClick={() => props.callBack(1)}
                    />
                </div>
            </div>
        </div>
    );
};

export default FirstProcuration;
